import * as angular from "angular";
import template from "./entity-form.html";
import "./entity-form.less";
import viewModesSection from "../../../../../view-modes-section";
import entityFormViewer from "./entity-form-viewer/entity-form-viewer";
import entityFormEditor from "./entity-form-editor/entity-form-editor";

export function controller() {
	const ctrl = this;

	ctrl.$onChanges = onChanges;
	ctrl.getHeaderTitle = getHeaderTitle;
	ctrl.getInitialMode = getInitialMode;

	ctrl.$onInit = () => {
		ctrl.isNewEntity = ctrl.entity === undefined;
		ctrl.entityTypeDisplayName = ctrl.entityType.Name
			?? ctrl.entityType.Type?.Name
			?? ctrl.entityType.Code;
		ctrl.draft = ctrl.entity;
	};

	function onChanges(changes) {
		const entityChange = changes.entity;
		if(!entityChange || entityChange.isFirstChange()) {
			return;
		}

		ctrl.isNewEntity = entityChange.currentValue === undefined;
		ctrl.draft = entityChange.currentValue;
	}

	function getInitialMode() {
		return ctrl.isNewEntity ? "edit" : ctrl.initialMode;
	}

	function getHeaderTitle() {
		const titleEntity = ctrl.draft ?? ctrl.entity;
		const titleName = titleEntity?.Name?.trim();
		const titleCode = ctrl.isNewEntity && ctrl.entityType.IsCodeSystemManaged
			? undefined
			: titleEntity?.Code?.trim();

		return titleName
			|| titleCode
			|| (ctrl.isNewEntity ? `New ${ctrl.entityTypeDisplayName}` : "--");
	}
}

export default angular.module("vesl.components.entity-form", [
	viewModesSection,
	entityFormViewer,
	entityFormEditor
])
	.component("entityForm", {
		controller,
		template,
		bindings: {
			entity: "<",
			readonly: "<",
			onCreate: "&",
			save: "&",
			nameComponentOptions: "<",
			entityType: "<",
			post: "=",
			initialMode: "<"
		}
	})
	.name;
